/* Turns the butterfly's clicks into an effect level from 1 to 4. A lone click gets a random
   level from 1 to 3; `l4Rate` or more clicks a second get level 4. No clock inside: you pass in
   the timestamps and the level RNG, so it's deterministic. */

export interface ClickGestureConfig {
  /** How many clicks within `window` seconds push a click up to level 4. */
  l4Rate: number;
  /** The rolling window the clicks are counted over, in seconds. */
  window: number;
}

export const CLICK_GESTURE_DEFAULTS: ClickGestureConfig = {
  l4Rate: 3,
  window: 1,
};

export class ClickGesture {
  private times: number[] = [];

  constructor(
    private readonly cfg: ClickGestureConfig = CLICK_GESTURE_DEFAULTS,
    /** Picks a level from 1 to 3 for a lone click. */
    private readonly randLevel: () => number = () => 1 + Math.floor(Math.random() * 3),
  ) {}

  /** Counts a click at `now` (in seconds) and returns its effect level, 1 to 4. */
  click(now: number): number {
    const c = this.cfg;
    this.times.push(now);
    const cut = now - c.window;
    while (this.times.length > 0 && this.times[0]! < cut) this.times.shift();
    const rate = this.times.length; // clicks in the window (with a 1s window, clicks per second)

    if (rate >= c.l4Rate) return 4;
    return this.clampL1to3(this.randLevel());
  }

  private clampL1to3(n: number): number {
    return n < 1 ? 1 : n > 3 ? 3 : Math.floor(n);
  }
}
